import { useState, useEffect, useRef } from 'react';
import { Dropdown, Button } from 'antd';
import { MoreOutlined } from '@ant-design/icons';

const AUTO_CLOSE_MS = 5000; // close after 5 seconds

const ActionDropdown = ({ record, actionOptions, handleActionClick }) => {
  const [open, setOpen] = useState(false);
  const timerRef = useRef(null);

  const clearTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  };

  // Start or reset the auto-close timer whenever the dropdown opens
  useEffect(() => {
    clearTimer();
    if (open) {
      timerRef.current = setTimeout(() => setOpen(false), AUTO_CLOSE_MS);
    }
    return clearTimer; // cleanup on close or unmount
  }, [open]);

  return (
    <Dropdown
      open={open}
      onOpenChange={(nextOpen) => setOpen(nextOpen)}
      menu={{
        items: actionOptions,
        onClick: ({ key }) => {
          const numKey = Number(key);
          const option = actionOptions.find((item) => item.key === numKey);
          handleActionClick(record, option);
          setOpen(false);
        },
      }}
      trigger={['click']}
    >
      <Button
        type="text"
        icon={<MoreOutlined />}
        onClick={(e) => e.stopPropagation()}
      />
    </Dropdown>
  );
};

export default ActionDropdown;